module.exports = __webpack_public_path__ + "img/3.1.9236be4b.jpg";